import type { JSX } from 'react';
import { clasesDeEtiqueta, type EtiquetaCita } from './etiquetaCita';

/** Etiqueta unificada de una cita con su color (la misma que ve recepción en el calendario del CRM) y, si lo tiene, su código de turno. */
export function EtiquetaCitaBadge({ etiqueta, turno }: { readonly etiqueta?: EtiquetaCita | null; readonly turno?: string | null }): JSX.Element | null {
  // Sin etiqueta (servidor anterior a la Sala): no se inventa un estado.
  if (!etiqueta) return null;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        data-etiqueta={etiqueta.clave}
        className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap ${clasesDeEtiqueta(etiqueta).badge}`}
      >
        {etiqueta.texto}
      </span>
      {turno ? <span className="rounded px-1.5 py-0.5 font-mono text-[10px] font-semibold bg-secondary text-hce-ink">{turno}</span> : null}
    </span>
  );
}
